import { subject } from "@casl/ability";

import { SUBJECT_PAYMENT } from "../../../models/role/subject";
import { STATUS_NEW_PAYMENT } from "../constants/transactionStatuses";

import type Payment from "../models/Payment";

export function transformPaymentResponse(payment: Payment): Payment {
  const notifications = payment.notifications
    ?.sort(
      ({ createdAt: dateA }, { createdAt: dateB }) =>
        new Date(dateB).getTime() - new Date(dateA).getTime()
    )
    .map((notification) =>
      Object.assign(notification, {
        notificationResponses: notification.notificationResponses.sort(
          (responseA, responseB) => responseA.retry - responseB.retry
        ),
      })
    );

  const statusUpdates = [
    {
      createdAt: payment.createdAt,
      newStatus: STATUS_NEW_PAYMENT,
    },
    ...(payment.statusUpdates ?? []),
  ];

  return subject(
    SUBJECT_PAYMENT,
    Object.assign(payment, { notifications }, { statusUpdates })
  );
}
